module.exports = __webpack_public_path__ + "img/190218_AM_Webseite_16_9_025.17d0a0c8.jpg";